import { ControlProps } from '../../types/ControlProps';
import { Check } from '../icons/Check';
import { RadioButtonIcon } from '../icons/RadioButtonIcon';
import { Info } from '../icons/Info';

export const Control = ({
    groupName,
    option,
    value,
    type,
    disabled,
    onClick,
    errorMessage,
}: ControlProps) => {

    let isCheckbox = type === 'checkbox';
    let isRadio = type === 'radio';

    let bgColor = value ? 'bg-bluestone-light' : 'bg-white';
    let borderColor = value ? '' : 'border border-bluestone-light/20';
    let hoverCheckbox = isCheckbox && value && !disabled ? 'hover:bg-[#0f2f56]' : '';
    let hoverRadio = isRadio && value && !disabled ? 'p-0 hover:fill-[#0f2f56] ' : '';

    let focus = value && !disabled ? 'focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-bluestone-light' : '';

    let borderRadius = isRadio ? 'rounded-full' : 'rounded';


    if (disabled && value) {
        bgColor = 'bg-[#606f82]'
    }
    if (disabled && !value) {
        bgColor = 'bg-[#e2e2e2]'
    }

    const toggleValue = () => {
        if (!disabled) {
            value = !value;
            onClick();
        }
    }


    return (
        <div>

            <div className="h-6 justify-start items-center gap-3 inline-flex">
                <div
                    className={`
            w-6 h-6 p-0.5 justify-center items-center inline-flex overflow-hidden cursor-pointer
            ${bgColor} ${borderColor} ${borderRadius} ${hoverCheckbox} ${hoverRadio} ${focus} 
            `}
                    onClick={toggleValue}>
                    {isCheckbox && value && <Check variant="light" className="" />}
                    {isRadio && value && <RadioButtonIcon variant="light" className={`${hoverRadio}`} />}
                </div>
                <label className="text-bluestone-light text-base font-normal font-['Inter'] leading-normal select-none cursor-pointer" onClick={toggleValue}>{option}</label>
            </div>
            {errorMessage && (
                <div className='flex text-error mt-2'>
                    <Info variant='currentColor' className='mr-2' />
                    {errorMessage}
                </div>
            )}
        </div>
    );
};
